import axios from 'axios';
const GOOGLE_PATH = '/integrations/google';
const TWILIO_PATH = '/click_to_call/verifications/';

class IntegrationsApi {
  beginGoogleIntegration(databaseId, userId) {
    return axios.post(GOOGLE_PATH, {
      integrations_google_integration: {
        calendar_database_id: databaseId,
        user_id: userId
      }
    });
  }

  cancelGoogleIntegration(userId) {
    return axios.delete(`${GOOGLE_PATH}/${userId}`);
  }

  cancelTwilioIntegration(id, userId) {
    return axios.delete(`${TWILIO_PATH}/${id}?user_id=${userId}`);
  }

  updateGoogleIntegration(databaseId, userId) {
    return axios.patch(`${GOOGLE_PATH}/${userId}`, {
      integrations_google_integration: {
        calendar_database_id: databaseId
      }
    });
  }

  handleCalendarImport(calendar, path, userId) {
    return axios.post(path, {
      import: {
        id: calendar.id,
        name: calendar.name,
        user_id: userId
      }
    });
  }
}

export default IntegrationsApi;
